module.exports = __webpack_public_path__ + "static/media/29EUNOG3.9977b126.jpg";